'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (change) {
  window.scrollBy(change.x, change.y);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/window/scroll-window.js
// module id = 1944
// module chunks = 0